// extracted by mini-css-extract-plugin
export default {"page":"c95df1fd2692","error":"bb1ebef848f5","header":"b8ba1f0d919d","ad":"d9ee0b9b5abe","navigation":"e633cb0b3b57","content":"aeb57e9d3e5d"};